import { useMemo, useState } from 'react';
import { useGetServiceVisitTypesQuery } from '../services';
import { ServiceVisitTypeFilters } from '../models';

const INITIAL_FILTER: ServiceVisitTypeFilters = {
  name: undefined,
  type: undefined,
  logisticOperatorId: undefined,
};

const useServiceVisitTypes = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState<ServiceVisitTypeFilters>(INITIAL_FILTER);

  const { data, isLoading, isFetching, error, refetch } =
    useGetServiceVisitTypesQuery({
      paginated: { page, pageSize },
      filters,
    });

  const items = data?.items ?? [];
  const totalItems = data?.count ?? 0;
  const totalPages = useMemo(
    () => Math.max(1, Math.ceil(totalItems / pageSize)),
    [totalItems, pageSize]
  );

  const handleSearch = (nextFilters: ServiceVisitTypeFilters) => {
    setPage(1);
    setFilters(nextFilters);
  };

  const handlePageChange = (nextPage: number) => setPage(nextPage);

  const handleRowsPerPageChange = (nextPageSize: number) => {
    setPage(1);
    setPageSize(nextPageSize);
  };

  return {
    items,
    totalItems,
    totalPages,
    page,
    pageSize,
    filters,
    initialFilter: INITIAL_FILTER,
    isLoading,
    isFetching,
    error,
    refetch,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
  };
};

export default useServiceVisitTypes;
